import { IncomingMessage } from 'http';
import { api } from 'api';
import { State, Store } from 'store/types';
import { getDomain, getHostname, getRegion } from 'utils';
import { getLang } from '../cookies';
import { GlobalEvents } from '../global';
import { FETCH_MODEL } from './model-json-constants';
import { ModelJson } from './model-json-types';

/**
 * Загрузка данных модели
 * @param {string} host
 * @param {string} url
 * @param {Store} store
 * @returns {Promise<ModelJson | SeasonStartModelJson>}
 */
export const getModel = (host: string, url: string, store: Store) => {
  const { orchestratorHost, useCredentials, apiKey, requestID, cookies } = store.get();

  const hostname = getHostname(host);
  const domain = getDomain(hostname);
  const region = getRegion(hostname, domain);
  const lang = getLang(cookies);

  const indexOfStartQueryString = url.indexOf('?');
  const pathname = indexOfStartQueryString === -1 ? url : url.substring(0, indexOfStartQueryString);

  return api.get<ModelJson>(
    'getModel',
    { pathname: pathname.replace('/kz/', '/'), region, lang },
    { orchestratorHost, useCredentials, apiKey, requestID }
  );
};

/**
 * Экшен загрузки данных модели
 * @param {IncomingMessage} req
 * @param {Store} store
 * @returns {Promise<State>}
 */
export const loadModelJsonAction = (req: IncomingMessage, store: Store): Promise<State> =>
  new Promise<State>(resolve => {
    const { headers = {} } = req;
    const { 'x-forwarded-host': referer, host = '', 'x-okapi-url': url } = headers;

    store.dispatch(GlobalEvents.setRequestParams, {
      orchestratorHost: process.env.ORCHESTRATOR_HOST,
      useCredentials: process.env.USE_CREDENTIALS === '1',
      apiKey: process.env.API_KEY,
    });
    store.dispatch(FETCH_MODEL.init, {
      host: typeof referer === 'string' ? referer : host,
      url: typeof url === 'string' ? url : '/',
    });

    const unsub = store.on('@dispatch', state => {
      if (state.modelJson?.loading) {
        return;
      }

      unsub();
      resolve(store.get());
    });
  });
